import colors from '../_shared/colors';

export default {
  container: `
    display: flex;
    flex: 1;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  `,
  title: `
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 30px;
  `,
  subTitle: `
    font-size: 12px;
  `,
  error: `
    color: ${colors.error};
    font-size: 14px;
    text-align: center;
    max-width: 300px;
  `,
  inputContainer: `
    margin-top: 30px;
    width: 80%;
    max-width: 400px;
    border: 1px solid ${colors.inputBorder};
    padding: 30px;
  `,
  fgPassword: `
    position: absolute;
    top: 7px;
    right: 0px;
    color: ${colors.labelColor};
    font-size: 10px;
    float: right;
    cursor: pointer;
  `,
  buttonContainer: `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 0;
    martin-top: -10px;
  `,
  passwordPrompt: `
    text-align: justify;
  `,
  brandedLoginForm: `
    padding-top: 20px;
    width: 80%;
    max-width: 300px;
  `,
};
